import type { Translation } from './es.js';

export const pt: Translation = {
  common: {
    save: 'Salvar',
    saving: 'Salvando...',
    saved: 'Alteracoes salvas',
    saveError: 'Nao foi possivel salvar as alteracoes',
    unsavedChanges: 'Alteracoes nao salvas',
    unsavedPrompt: 'Salve suas alteracoes ou descarte-as antes de sair desta pagina.',
    keepEditing: 'Continuar editando',
    discardChanges: 'Descartar alteracoes',
    loading: 'Carregando...',
    language: 'Idioma',
    enabled: 'Ativado',
    disabled: 'Desativado',
    close: 'Fechar',
    discard: 'Descartar',
    delete: 'Excluir',
  },
  nav: {
    dashboard: 'Painel',
    analytics: 'Analises',
    designer: 'Editor do formulario',
    shippingRates: 'Metodos de envio',
    salesBooster: 'Impulsionador de vendas',
    quantityOffers: 'Ofertas por quantidade',
    tracking: 'Pixels de rastreamento',
    settings: 'Configuracoes',
    appName: 'Releasit COD',
    collapse: 'Recolher',
    expand: 'Expandir',
  },
  shippingRates: {
    title: 'Metodos de envio',
    addRate: 'Adicionar metodo',
    empty: 'Voce ainda nao criou metodos de envio. Clique em "Adicionar metodo" para comecar.',
    colName: 'Nome',
    colPrice: 'Preco',
    colCondition: 'Condicao',
    colActions: 'Acoes',
    alwaysVisible: 'Sem condicao, sempre visivel.',
    edit: 'Editar',
    rateName: 'Nome do metodo',
    rateDescription: 'Descricao do metodo',
    ratePrice: 'Preco do metodo',
    conditionsHeading: 'Condicoes do metodo',
    addCondition: 'Adicionar condicao',
    conditionType: 'Tipo de condicao',
    conditionValue: 'Valor',
    product: 'Produto',
    selectProduct: 'Selecionar produto',
    productCount: '{{count}} produtos',
    ct_order_total_gte: 'Total do pedido maior ou igual a',
    ct_order_total_lt: 'Total do pedido menor que',
    ct_quantity_gte: 'Quantidade de produtos maior ou igual a',
    ct_quantity_lt: 'Quantidade de produtos menor que',
    ct_cart_contains_product: 'O carrinho contem o produto',
    ct_cart_not_contains_product: 'O carrinho nao contem o produto',
    // Country gating is disabled (see ShippingRates.tsx). These four strings and
    // `countrySummary` below are kept, unused, so switching it back on needs no re-translation.
    countryOnly: 'Ativar este metodo apenas para paises especificos',
    countryCodes: 'Paises',
    addCountry: 'Adicionar um pais...',
    countryCodesHelp: 'O metodo so aparece para compradores dos paises que voce escolher aqui.',
    lastRateHelp:
      'Sua loja precisa de pelo menos um metodo de envio, por isso o ultimo nao pode ser excluido.',
    conditionsSummary: '{{count}} condicao(oes)',
    countrySummary: '{{count}} pais(es)',
  },
  quantityOffers: {
    title: 'Ofertas por quantidade',
    addOffer: 'Adicionar oferta',
    search: 'Buscar',
    searchPlaceholder: 'Buscar por nome...',
    priority: 'Prioridade',
    enabled: 'Ativa',
    name: 'Nome',
    actions: 'Acoes',
    newOfferName: 'Nova oferta',
    emptyTitle: 'Configure suas ofertas por quantidade',
    emptyText:
      'Aqui voce pode criar ofertas por quantidade para o seu formulario COD. As ofertas aparecem diretamente no formulario ou na pagina do produto.',
    noResults: 'Nenhuma oferta encontrada com esse nome',
    noResultsText: 'Tente outro nome, ou limpe a busca para ver todas as suas ofertas.',
    removedTitle: 'Suas ofertas ainda nao foram excluidas',
    removedText: 'Salve para exclui-las definitivamente, ou descarte para recupera-las.',
    edit: 'Editar',
    drag: 'Arraste para reordenar',
    duplicate: 'Duplicar',
    delete: 'Excluir',
    copyLabel: 'Copia',
    conflictTitle: 'Revise suas ofertas por quantidade',
    conflictWarning:
      'O produto {{product}} e usado em varias ofertas por quantidade. Revise, pois apenas uma sera exibida e as demais nao funcionarao.',
  },
  quantityOfferEditor: {
    addTitle: 'Adicionar oferta',
    editTitle: 'Editar oferta',
    active: 'Ativa',
    inactive: 'Inativa',
    back: 'Voltar',
    saveRequirement: 'Adicione um nome de oferta e ao menos um produto para salvar.',
    configureOffer: '1. Configure a oferta',
    offerName: 'Nome da oferta',
    offerNamePlaceholder: 'Nova oferta',
    productsHeading: 'Crie ofertas por quantidade para estes produtos:',
    selectProducts: 'Selecionar produtos',
    productId: 'ID do produto',
    removeProduct: 'Remover produto',
    configureTiers: '2. Configure suas ofertas por quantidade',
    tableTitle: 'Titulo',
    tableQuantity: 'Quantidade',
    addTier: 'Adicionar oferta',
    editTier: 'Editar oferta',
    deleteTier: 'Excluir',
    selectProductPlaceholder: 'Selecionar produto',
    defaultTierOne: 'Compre 1 unidade',
    defaultTierTwo: 'Compre 2 unidades e ganhe 25% de desconto!',
    defaultSaveZero: 'Economize 0%',
    tier: {
      title: 'Titulo',
      titleHelp: 'Use {product_name} para inserir dinamicamente o nome do produto neste campo.',
      quantity: 'Quantidade',
      preselect: 'Pre-selecionar esta oferta',
      bestDeal: 'Mostrar o selo "Melhor oferta"',
      bestDealHelp:
        'O selo aparece ao lado da placa de economia na oferta pre-selecionada, portanto apenas uma oferta pode exibi-lo.',
      bestDealText: 'Texto do selo',
      bestDealBgColor: 'Cor de fundo do selo',
      bestDealTextColor: 'Cor do texto do selo',
      bestDealRadius: 'Raio da borda do selo',
      bestDealAnimation: 'Animacao do selo',
      hideComparePrice: 'Ocultar o preco comparativo na oferta',
      discountType: 'Tipo de desconto',
      discountPercentage: 'Porcentagem',
      discountFixed: 'Valor fixo',
      discountNone: 'Sem desconto',
      discountValue: 'Valor do desconto',
      priceColor: 'Cor do preco',
      plaqueText: 'Texto da placa',
      plaqueTextColor: 'Cor do texto da placa',
      plaqueBgColor: 'Cor de fundo da placa',
      imageUrl: 'URL da imagem',
    },
    design: {
      heading: '3. Personalize o design e o comportamento',
      selectMode: 'Selecione o modo e o modelo',
      displayAboveBuyButton: 'Exibir acima do botao de compra (apenas no modo pop-up)',
      templateClassic: 'Classico',
      templateModern: 'Moderno',
      templateVertical: 'Vertical',
      verticalLimitHelp:
        'O modelo vertical exibe ate {{max}} ofertas para que os cartoes fiquem legiveis.',
      verticalUnavailableHelp:
        'O modelo vertical exibe apenas {{max}} ofertas para que os cartoes fiquem legiveis. Voce tem {{offers}}, entao ele nao pode ser selecionado: os compradores nunca poderiam escolher as ofertas a mais. Remova uma oferta para usa-lo.',
      palette: 'Selecione uma paleta',
      bgColor: 'Cor de fundo',
      borderColor: 'Cor da borda',
      pricesSize: 'Tamanho dos precos',
      borderRadius: 'Raio da borda',
      hideProductImage: 'Ocultar a imagem do produto',
      hideVariantNumbers:
        'Ocultar os numeros ao lado dos seletores de variante (se o produto tiver variantes)',
      disableVariantSelectors: 'Desativar os seletores de variante (se o produto tiver variantes)',
    },
  },
  productPicker: {
    title: 'Adicionar produtos',
    searchPlaceholder: 'Buscar produtos',
    add: 'Adicionar',
    cancel: 'Cancelar',
    selectedCount: '{{count}} produtos selecionados',
    loadMore: 'Carregar mais',
    loading: 'Carregando produtos...',
    empty: 'Nenhum produto encontrado.',
    error: 'Nao foi possivel carregar os produtos.',
  },
  dashboard: {
    title: 'Painel',
    subtitle: 'Resumo do seu formulario de pagamento na entrega',
    appStatus: 'Status do aplicativo',
    appStatusHelp: 'Ative ou desative o formulario em toda a sua loja',
    formViews: 'Visualizacoes do formulario',
    formOpens: 'Aberturas do formulario',
    ordersCreated: 'Pedidos criados',
    welcomeTitle: 'A Releasit chegou a Tiendanube',
    welcomeBody:
      'Seus compradores preenchem um formulario de pagamento na entrega na pagina do produto e um pedido real e criado na sua loja.',
    welcomeCta: 'Personalize seu formulario',
    setupTitle: 'Conclua sua configuracao',
    setupDoneTitle: 'Configuracao concluida',
    setupProgress: '{{done}} de {{total}} concluidos',
    setupHide: 'Ocultar',
    setupShow: 'Mostrar',
    stepOptional: 'Opcional',
    steps: {
      activate: {
        title: 'Ative o aplicativo',
        help: 'Enquanto estiver desativado, os compradores nao veem o formulario.',
        action: 'Ativar',
      },
      customize: {
        title: 'Personalize seu formulario',
        help: 'Ajuste os campos, os textos e as cores a sua marca.',
        action: 'Personalizar',
      },
      shipping: {
        title: 'Configure os metodos de envio',
        help: 'Adicione pelo menos um metodo alem do frete gratis inicial.',
        action: 'Configurar',
      },
      offer: {
        title: 'Crie uma oferta por quantidade',
        help: 'Ofereca um desconto para quem comprar mais de uma unidade.',
        action: 'Criar',
      },
      pixel: {
        title: 'Adicione um pixel de rastreamento',
        help: 'Envie suas conversoes de pagamento na entrega para suas plataformas de anuncios.',
        action: 'Adicionar',
      },
      order: {
        title: 'Receba seu primeiro pedido',
        help: 'Marcado automaticamente quando um comprador conclui o formulario.',
        action: 'Ver analises',
      },
    },
    liveTitle: 'O que esta ativo agora',
    liveVisibility: 'Visibilidade',
    liveMode: 'Modo de exibicao',
    liveOffers: 'Ofertas por quantidade ativas',
    livePixels: 'Pixels ativos',
    liveCoverage: 'Cobertura',
    liveCoverageOff: 'Desativada',
    liveChange: 'Alterar',
    modePopup: 'Janela pop-up',
    modeEmbedded: 'Integrado',
    lifetimeRevenue: 'Receita total',
    noOrdersYet: 'Ainda nao ha pedidos',
    performanceTitle: 'Desempenho total',
    avgOrder: '{{amount}} por pedido',
    recentOrders: 'Pedidos recentes',
    viewAllOrders: 'Ver todos os pedidos',
    scopeFix: 'Autorizar o aplicativo novamente',
    scope: {
      write_orders: {
        title: 'Nao e possivel criar pedidos',
        body: 'Sua loja nao concedeu ao aplicativo a permissao para criar pedidos, entao todo envio do formulario falha. Habilite a permissao e autorize o aplicativo novamente.',
      },
      read_coupons: {
        title: 'Nao e possivel validar os codigos de desconto',
        body: 'Sua loja nao concedeu ao aplicativo a permissao para ler cupons, entao os codigos de desconto do formulario sao sempre recusados. Habilite a permissao e autorize o aplicativo novamente.',
      },
    },
    offerConflictTitle: 'Ofertas por quantidade sobrepostas',
    offerConflictBody:
      '"{{product}}" esta em mais de uma oferta ativa. Apenas a de maior prioridade e exibida.',
    offerConflictFix: 'Revisar as ofertas',
  },
  analytics: {
    title: 'Analises',
    subtitle: 'Desempenho do seu formulario de pagamento na entrega (em horario UTC)',
    dateRange: 'Periodo',
    presets: {
      last7: 'Ultimos 7 dias',
      last30: 'Ultimos 30 dias',
      last90: 'Ultimos 90 dias',
      thisMonth: 'Este mes',
      custom: 'Personalizado',
    },
    from: 'De',
    to: 'Ate',
    invalidRange: 'Escolha uma data inicial anterior ou igual a data final.',
    lifetimeTitle: 'Parabens!',
    lifetimeBody: 'Seu formulario de pagamento na entrega gerou {{amount}} em receita total.',
    formOpens: 'Aberturas do formulario',
    orders: 'Pedidos',
    conversionRate: 'Taxa de conversao',
    revenue: 'Receita',
    aov: 'Valor medio do pedido',
    trendOpens: 'Aberturas ao longo do tempo',
    trendOrders: 'Pedidos ao longo do tempo',
    trendRevenue: 'Receita ao longo do tempo',
    noData: 'Ainda sem dados',
    tooltipOpens_one: '{{value}} abertura do formulário',
    tooltipOpens_other: '{{value}} aberturas do formulário',
    tooltipOrders_one: '{{value}} pedido',
    tooltipOrders_other: '{{value}} pedidos',
    quantityOffers: 'Ofertas por quantidade',
    qoSelections: 'Pedidos com uma oferta',
    qoRevenue: 'Contribuicao para a receita',
    qoDiscount: 'Desconto concedido',
    qoNote:
      'A taxa de exibicao e selecao aparecera quando as impressoes das ofertas forem rastreadas.',
  },
  designer: {
    title: 'Editor do formulario',
    subtitle: 'Personalize e visualize seu formulario',
    mode: 'Modo de exibicao',
    modePopup: 'Pop-up',
    modeEmbedded: 'Incorporado',
    popupNote:
      'Quando seus clientes clicarem no <b>Botao de compra</b> do app, o formulario abrira como um pop-up na pagina.',
    embeddedNote:
      'Seus clientes verao o formulario incorporado diretamente nas paginas, entao nao precisarao clicar em nenhum botao para abri-lo.',
    tabs: {
      button: 'Botao',
      fields: 'Campos',
      coverage: 'Cobertura',
      appearance: 'Aparencia',
      text: 'Textos',
    },
    coverage: {
      heading: 'Cobertura de entrega',
      description:
        'Selecione as regioes para onde voce entrega. Os campos de provincia, cidade e CEP viram listas suspensas e sao validados ao finalizar o pedido.',
      label: 'Cobertura',
      countryLabel: 'Pais onde voce vende',
      countryHelp: 'Determina quais coberturas ficam disponiveis abaixo.',
      countryNone: 'Selecione um pais',
      none: 'Sem cobertura',
      noneForCountry: 'Ainda nao ha coberturas disponiveis para {{country}}.',
      noneUnknownCountry:
        'Nao foi possivel determinar o pais da sua loja, entao nenhuma cobertura pode ser oferecida.',
      appliesTo: 'Aplica-se a',
      fieldProvince: 'Provincia',
      fieldCity: 'Cidade',
      fieldPostal: 'CEP',
    },
    button: {
      text: 'Texto do botao',
      bgColor: 'Cor de fundo',
      textColor: 'Cor do texto',
      borderRadius: 'Raio da borda',
      borderWidth: 'Espessura da borda',
      borderColor: 'Cor da borda',
      icon: 'Icone',
      iconBag: 'Sacola',
      iconCart: 'Carrinho',
      iconNone: 'Sem icone',
    },
    fields: {
      heading: 'Campos do formulario',
      reorderHint: 'Arraste para reordenar os campos. Abra um campo para editar suas opcoes.',
      headerCard: 'Cabecalho',
      fieldTitle: 'Campo: {{label}}',
      drag: 'Arraste para reordenar',
      hide: 'Ocultar campo',
      show: 'Mostrar campo',
      enabled: 'Visivel',
      required: 'Obrigatorio',
      showIcon: 'Mostrar icone do campo',
      label: 'Rotulo',
      placeholder: 'Texto de exemplo',
      coverageLocked:
        'Este campo faz parte da cobertura que voce escolheu, entao sempre aparece. Sem ele, o proximo menu fica vazio e a cobertura deixa de validar os pedidos.',
      minLength: 'Comprimento minimo',
      maxLength: 'Comprimento maximo',
      errorText: 'Texto de erro de valor invalido',
      errorHelp:
        'Se deixar este campo vazio, o app usara seu <b>texto de erro generico</b> quando o cliente inserir um valor invalido. Voce pode edita-lo na aba Textos.',
    },
    fieldsStyle: {
      heading: 'Estilo dos campos',
      hideLabels: 'Ocultar rotulos dos campos',
      bgColor: 'Cor de fundo do campo',
      textColor: 'Cor do texto do campo',
      placeholderColor: 'Cor do texto de exemplo',
      borderColor: 'Cor da borda',
      borderWidth: 'Espessura da borda',
      borderMode: 'Borda',
      noBorder: 'Sem borda',
      border: 'Com borda',
      borderPosition: 'Posicao da borda',
      posAll: 'Todos os lados',
      posTop: 'Topo',
      posRight: 'Direita',
      posBottom: 'Base',
      posLeft: 'Esquerda',
      borderRadius: 'Raio da borda',
      shadow: 'Sombra',
      sizing: 'Tamanho',
    },
    appearance: {
      heading: 'Aparencia geral',
      borderRadius: 'Raio da borda',
      bgColor: 'Cor de fundo',
      textColor: 'Cor do texto',
      accentColor: 'Cor de destaque',
    },
    productCard: {
      heading: 'Resumo do pedido',
      show: 'Mostrar resumo do pedido',
      bgColor: 'Cor de fundo',
      borderColor: 'Cor da borda',
      borderWidth: 'Espessura da borda',
      borderRadius: 'Raio da borda',
      hideQuantity: 'Ocultar controles de quantidade',
      qcBg: 'Fundo dos controles de quantidade',
      qcBorderColor: 'Cor da borda dos controles',
      qcBorderWidth: 'Espessura da borda dos controles',
      qcBorderRadius: 'Raio da borda dos controles',
    },
    totals: {
      heading: 'Resumo de totais',
      show: 'Mostrar resumo de totais',
      subtotalTitle: 'Titulo do subtotal',
      shippingTitle: 'Titulo do frete',
      totalTitle: 'Titulo do total',
      showTaxes: 'Mostrar mensagem de impostos',
      taxesMessage: 'Mensagem de impostos',
      bgColor: 'Cor de fundo',
      textColor: 'Cor do texto',
      borderColor: 'Cor da borda',
      borderWidth: 'Espessura da borda',
      borderRadius: 'Raio da borda',
      dividerColor: 'Cor do divisor',
      dividerWidth: 'Espessura do divisor',
    },
    discount: {
      lineText: 'Texto da linha de descontos',
      fieldLabel: 'Rotulo do campo de codigo',
      applyText: 'Texto do botao Aplicar',
      buttonBg: 'Cor de fundo do botao Aplicar',
      buttonText: 'Cor do texto',
      borderColor: 'Cor da borda',
      borderRadius: 'Raio da borda',
      borderWidth: 'Espessura da borda',
      inputBg: 'Cor de fundo do campo',
      inputText: 'Cor do texto do campo',
      inputBorderColor: 'Cor da borda do campo',
      inputPlaceholderColor: 'Cor do texto de exemplo',
      inputBorderRadius: 'Raio da borda do campo',
      inputBorderWidth: 'Espessura da borda do campo',
      invalidError: 'Texto de erro de codigo invalido',
    },
    shipping: {
      freeText: 'Texto para frete gratis (se um metodo for gratuito)',
      bgColor: 'Cor de fundo',
      textColor: 'Cor do texto',
      borderColor: 'Cor da borda',
      activeBorderColor: 'Cor da borda ativa',
      borderWidth: 'Espessura da borda',
      borderRadius: 'Raio da borda',
    },
    validation: {
      empty: 'Este campo nao pode ficar vazio.',
      minChars: 'Deve ter pelo menos {{min}} caracteres.',
      maxChars: 'Nao pode ultrapassar {{max}} caracteres.',
      minValue: 'O valor minimo e {{min}}.',
      maxValue: 'O valor maximo e {{max}}.',
      minItems: 'Deve haver pelo menos {{min}}.',
      invalid: 'Este valor nao e valido.',
      saveBlocked: 'Verifique os campos destacados em vermelho.',
      saveBlockedElsewhere:
        'Uma configuracao invalida esta bloqueando o salvamento, mas nao pode ser editada nesta visualizacao.',
    },
    text: {
      headerTitle: 'Titulo do formulario',
      headerIcon: 'Mostrar icone',
      summarySection: 'Resumo do pedido',
      shippingLabel: 'Texto do frete',
      showDiscount: 'Mostrar codigo de desconto',
      shippingMethodSection: 'Metodo de envio',
      shippingMethodTitle: 'Titulo da secao',
      shippingMethodOption: 'Nome da opcao',
      shippingMethodPrice: 'Preco da opcao',
      addressSection: 'Endereco de entrega',
      terms: 'Texto dos termos e condicoes',
      termsUrl: 'Link dos termos e condicoes',
      messagesSection: 'Mensagens de erro',
      requiredError: 'Texto de campo obrigatorio',
      genericError: 'Texto de erro generico',
      genericErrorHelp: 'Usado quando um campo nao tem seu proprio texto de erro.',
    },
    fieldNames: {
      first_name: 'Campo de nome',
      last_name: 'Campo de sobrenome',
      phone: 'Campo de telefone',
      address: 'Campo de endereço',
      address_2: 'Campo de endereço 2',
      province: 'Campo de estado',
      city: 'Campo de cidade',
      postal_code: 'Campo de CEP',
      email: 'Campo de e-mail',
      order_note: 'Campo de nota do pedido',
      newsletter: 'Campo de inscrição de marketing',
      terms: 'Campo de aceitação dos termos',
    },
    blocks: {
      order_summary: 'Resumo do pedido',
      totals_summary: 'Resumo de totais',
      shipping_method: 'Metodo de envio',
      discount_code: 'Codigo de desconto',
      quantity_offers: 'Ofertas por quantidade',
      submit: 'Botao de envio',
      terms: 'Termos e condicoes',
      newsletter: 'Inscricao na newsletter',
      discountHint:
        'Permite que seus clientes insiram um codigo de desconto. Os codigos sao validados no checkout.',
      quantityOffersHint: 'Gerencie as ofertas e seu design na pagina de Ofertas por quantidade.',
      shippingRatesHint: 'Crie e gerencie os metodos de envio na pagina Metodos de envio.',
    },
    submit: {
      text: 'Texto do botao',
      textHelp: 'Use {order_total} para mostrar o total do pedido',
      bgColor: 'Fundo',
      textColor: 'Cor do texto',
      borderRadius: 'Raio da borda',
      fontSize: 'Tamanho da fonte',
    },
    terms: {
      textColor: 'Cor do texto',
      linkColor: 'Cor do link',
      fontSize: 'Tamanho da fonte',
      errorHelp:
        'Exibido quando o comprador envia sem aceitar. Deixe vazio para usar a mensagem geral de campo obrigatorio.',
    },
    newsletter: {
      text: 'Texto de inscricao',
      textColor: 'Cor do texto',
      fontSize: 'Tamanho da fonte',
    },
    addField: {
      button: 'Adicionar campo, botao ou imagem',
      modalTitle: 'Adicionar elemento',
      add: 'Adicionar',
      customText: 'Titulo ou texto',
      customTextDesc: 'Texto ou titulo personalizado',
      image: 'Imagem ou GIF',
      imageDesc: 'Envie uma imagem ou GIF',
      whatsapp: 'Botao do WhatsApp',
      whatsappDesc: 'Botao para comprar ou conversar no WhatsApp',
      textInput: 'Entrada de texto',
      textInputDesc: 'Campo de entrada de texto',
      dropdown: 'Lista suspensa',
      dropdownDesc: 'Menu com opcoes',
      singleChoice: 'Seleção única',
      singleChoiceDesc: 'Opcoes com selecao unica',
      checkbox: 'Caixa de seleção',
      checkboxDesc: 'Caixa para aceitar ou confirmar',
      date: 'Seletor de data',
      dateDesc: 'Campo para escolher uma data',
      link: 'Botao de link',
      linkDesc: 'Botao que abre um link',
    },
    custom: {
      label: 'Rotulo',
      placeholder: 'Texto de exemplo',
      required: 'Obrigatorio',
      showIcon: 'Mostrar icone do campo',
      iconLabel: 'Icone',
      connectTo: 'Conectar este campo a:',
      connectNothing: 'Nada',
      connect_first_name: 'Nome',
      connect_last_name: 'Sobrenome',
      connect_phone: 'Telefone',
      connect_email: 'E-mail',
      connect_address: 'Endereco',
      connect_number: 'Numero da rua',
      connect_address_2: 'Endereco 2',
      connect_locality: 'Bairro',
      connect_province: 'Provincia',
      connect_city: 'Cidade',
      connect_postal_code: 'CEP',
      connect_order_note: 'Observacao do pedido',
      minLength: 'Comprimento minimo',
      maxLength: 'Comprimento maximo',
      allowOnlyNumbers: 'Permitir apenas numeros neste campo',
      prefixText: 'Texto de prefixo',
      prefixHelp: 'Texto que seus clientes nao podem alterar.',
      errorText: 'Texto de erro de valor invalido',
      options: 'Valores separados por virgula',
      optionsHelp: 'Insira os valores separados por virgula. Exemplo: Vermelho,Verde,Azul',
      content: 'Texto',
      shortcodesText: 'Atalhos: {order_total} para o total, {product_name} para o nome do produto',
      align: 'Alinhamento',
      align_left: 'Esquerda',
      align_center: 'Centro',
      align_right: 'Direita',
      fontSize: 'Tamanho da fonte',
      fontWeight: 'Espessura da fonte',
      weight_normal: 'Normal',
      weight_bold: 'Negrito',
      textColor: 'Cor do texto',
      imageUrl: 'URL da imagem',
      imageSize: 'Tamanho da imagem',
      btnText: 'Texto do botao',
      subtitle: 'Subtitulo do botao',
      phone: 'Seu numero de WhatsApp',
      phoneHelp: 'Importante: inclua o codigo do pais no numero.',
      createOrder: 'Criar um pedido quando o botao for clicado',
      message: 'Mensagem predefinida do WhatsApp',
      shortcodesWa:
        'Atalhos: {page_url}, {products_summary_with_quantity}, {order_total}, {full_name}, {phone}, {email}, {full_address}, {order_note}',
      animation: 'Animacao do botao',
      anim_none: 'Nenhuma',
      anim_pulse: 'Pulso',
      anim_shake: 'Vibracao',
      anim_bounce: 'Salto',
      anim_tada: 'Tada',
      bgColor: 'Cor de fundo',
      borderColor: 'Cor da borda',
      borderRadius: 'Raio da borda',
      borderWidth: 'Espessura da borda',
      shadow: 'Sombra',
      url: 'URL do link',
    },
    preview: 'Pre-visualizacao',
  },
  // Shared page-state copy (empty / error / loading). One source for all eight pages —
  // see components/states.tsx.
  states: {
    errorTitle: 'Nao conseguimos carregar esta secao',
    errorText:
      'Verifique sua conexao e tente novamente. Se continuar, abra o aplicativo novamente pelo painel da sua loja.',
    retry: 'Tentar novamente',
    noDataTitle: 'Ainda nao ha dados',
    noDataText:
      'As metricas aparecerao aqui quando os compradores comecarem a usar seu formulario.',
  },
  tracking: {
    title: 'Pixels de rastreamento',
    subtitle:
      'Envie as conversoes dos seus pedidos contra entrega para suas plataformas de anuncios',
    masterEnable: 'Ativar o rastreamento',
    masterEnableHelp: 'Ativa ou desativa o disparo de todos os pixels configurados.',
    requireConsent: 'Exigir consentimento antes de rastrear',
    requireConsentHelp:
      'Se ativado, nenhum evento e enviado para suas plataformas de anuncios: nem visualizacoes nem compras. A loja nao consegue coletar o consentimento do comprador, entao ativar isso desliga todo o rastreamento.',
    addPixel: 'Adicionar pixel',
    empty: 'Clique em "Adicionar pixel" para comecar.',
    status: {
      active: 'Ativo',
      inactive: 'Desativado',
      incomplete: 'Falta configurar',
      failing: 'Com erros',
      unsupported: 'Nao pode enviar',
    },
    pixelLabel: 'Pixel da {{provider}}',
    newPixelName: 'Novo pixel',
    provider: 'Plataforma',
    providerMeta: 'Meta (Facebook / Instagram)',
    providerTiktok: 'TikTok',
    providerGoogleAds: 'Google Ads',
    providerGa4: 'Google Analytics 4',
    pixelId: 'ID do pixel',
    pixelIdHelpMeta: 'Seu ID de pixel da Meta (apenas numeros).',
    pixelIdHelpTiktok: 'Seu ID de pixel do TikTok.',
    pixelIdHelpGoogleAds: 'Seu ID de conversao do Google Ads (AW-XXXXXXXXX).',
    pixelIdHelpGa4: 'Seu ID de medicao do GA4 (G-XXXXXXX).',
    label: 'Rotulo de conversao',
    labelHelp: 'Apenas para Google Ads: o rotulo da acao de conversao.',
    enabled: 'Ativo',
    noServerPathTitle: 'Google Ads nao pode ser enviado pelo servidor',
    noServerPath:
      'As conversoes do Google Ads exigem a API do Google Ads (OAuth2 e token de desenvolvedor), que este app nao usa. Este pixel nao dispara. Para medir esses pedidos, adicione um pixel do Google Analytics 4 e vincule o GA4 ao Google Ads para importar a conversao.',
    accessToken: 'Token de acesso',
    accessTokenSet: 'Token salvo. Digite um novo para substitui-lo.',
    accessTokenPlaceholder: 'Colar token de acesso',
    accessTokenHelp: 'E salvo criptografado e nunca e enviado ao navegador.',
    clearToken: 'Remover token',
    testFail: 'Nao foi possivel enviar o evento de teste',
    failing: 'O ultimo envio pelo servidor deste pixel falhou:',
    delete: 'Excluir pixel',
    dupWarningTitle: 'Evite contar as conversoes duas vezes',
    dupWarningBody:
      'Se voce ja usa a integracao nativa do Facebook ou Google da Nuvemshop, ative apenas uma fonte de conversoes. Para os pedidos contra entrega (que nao passam pelo checkout nativo) deixe este app reportar a conversao; caso contrario, desative a fonte nativa para nao duplicar.',
  },
  settings: {
    title: 'Configuracoes',
    subtitle: 'Ajustes gerais do aplicativo',
    visibility: 'Visibilidade',
    visibilityHeading: 'Ative ou desative seu formulario',
    visibilityHelp:
      'Voce pode desativar o formulario, ou ativa-lo apenas nas paginas de produto, apenas no carrinho, ou em ambos.',
    visDisabled: 'Desativado',
    visCart: 'Apenas carrinho',
    visProduct: 'Apenas paginas de produto',
    visBoth: 'Carrinho e paginas de produto',
    visibilityEnabledNote: 'O formulario COD esta ativo na sua loja.',
    visibilityDisabledNote: 'O formulario esta desativado e nao aparecera na sua loja.',
    cartModeTitle: 'Pedido na pagina de produto',
    cartModeHeading: 'O que o formulario inclui no pedido',
    cartModeHelp:
      'Em uma pagina de produto, pedir apenas o produto que esta sendo visto, ou todo o carrinho mais o produto atual (adicionado quando ainda nao esta no carrinho).',
    cartModeProductOnly: 'Apenas produto',
    cartModeProductAndCart: 'Produto + Carrinho',
    thankYouTitle: 'Pagina de agradecimento',
    thankYouHeading: 'Pagina pos-compra',
    thankYouHelp:
      'Escolha o que os compradores veem apos fazer um pedido: uma pagina personalizada, um redirecionamento para uma URL, ou um chat do WhatsApp com os dados do pedido.',
    thankYouEnable: 'Mostrar uma pagina de agradecimento personalizada',
    thankYouMode: 'O que acontece apos um pedido',
    thankYouModePage: 'Pagina personalizada',
    thankYouModeUrl: 'Botao para URL',
    thankYouModeWhatsapp: 'Botao para WhatsApp',
    thankYouPageLabel: 'Conteudo da pagina (HTML)',
    thankYouPlaceholders:
      'Shortcodes: {order_id}, {order_number}, {order_total}, {products_summary_with_quantity}, {product_title}, {product_quantity}, {first_name}, {last_name}, {full_name}, {phone}, {email}, {address}, {address2}, {province}, {city}, {zip_code}, {order_note}, {shipping_rate_name}.',
    thankYouEditHtml: 'Editar o HTML',
    thankYouPreviewLabel: 'Pre-visualizacao ao vivo',
    thankYouPreviewEmpty: 'Nada para mostrar ainda: escreva ou cole o seu HTML acima.',
    thankYouUrlLabel: 'URL de redirecionamento',
    thankYouUrlHelp:
      'Apos um pedido bem-sucedido o comprador ve um botao que abre esta URL em uma nova aba (ex. https://seu-site.com/obrigado).',
    thankYouUrlRequired:
      'Adicione a URL que o botao deve abrir, ou escolha "Pagina personalizada".',
    thankYouUrlInvalid:
      'Escreva um endereco completo comecando com https://, ou um caminho da sua loja comecando com /.',
    thankYouPhoneLabel: 'Numero do WhatsApp',
    thankYouPhoneHelp: 'Inclua o codigo do pais, ex. 57 300 123 4567.',
    thankYouPhoneRequired:
      'Adicione o numero do WhatsApp que o botao deve abrir, ou escolha "Pagina personalizada".',
    thankYouPhoneInvalid: 'Escreva o numero com o codigo do pais, ex. 57 300 123 4567.',
    thankYouMessageLabel: 'Mensagem predefinida',
    thankYouWaPreview: 'Abre',
    templatesHeading: 'Comecar a partir de um modelo',
    templatesHelp:
      'Escolha um design pronto e insira-o, ou escolha "HTML proprio" para escrever a pagina voce mesmo. Para partir de um design, copie o HTML dele antes.',
    templateCustomHelp:
      'Escreva ou cole o seu proprio HTML em "Editar o HTML", abaixo. Para partir de um dos designs, selecione-o acima e use "Copiar HTML".',
    templateCopy: 'Copiar HTML',
    templateCopied: 'HTML copiado. Cole em "HTML proprio".',
    templateCopyFailed:
      'Seu navegador bloqueou a copia. Insira o modelo e depois mude para "HTML proprio" para edita-lo.',
    templateLanguage: 'Idioma do modelo',
    templateLanguageHelp:
      'Comeca no idioma da sua loja. Mude se voce fala com seus compradores em outro; muda so o texto do modelo, nao o seu painel.',
    templateCallToConfirm: 'Eu ligo para os compradores para confirmar os pedidos',
    templateCallToConfirmHelp:
      'Muda a linha de contato do modelo. Aplicado ao inserir; se mudar depois, insira o modelo novamente.',
    templateUse: 'Usar este modelo',
    templateCurrent: 'Modelo atual:',
    templateCustom: 'HTML proprio',
    templateNone: 'Nenhum ainda',
    templateInUse: 'Em uso',
    templateReplaceTitle: 'Substituir o conteudo atual',
    templateReplaceBody:
      'Voce ja escreveu conteudo na pagina de agradecimento. Inserir este modelo substitui tudo e nao pode ser desfeito.',
    templateReplaceConfirm: 'Substituir',
    templateReplaceCancel: 'Cancelar',
    templateApplied: 'Modelo inserido. Lembre-se de salvar.',
    templateClean: 'Minimalista',
    templateBold: 'Destaque',
    templateReceipt: 'Recibo',
    templateSoft: 'Amigavel',
    templateSteps: 'Etapas',
  },
};
